import React from "react";
import GetContactEntries from "../../Administrative/GetContactEntries";

const ContactFormEntries = () => {
  return (
    <div>
      <GetContactEntries role="Super Admin" />
    </div>
  );
};

export default ContactFormEntries;
